import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Speed dial button element, used for clickable iconbuttons with label
 *
 * @prop {String} icon - used to define a Fontawesome icon
 * @prop {Number} size - used to define a specific size for the icon (default is 20)
 * @prop {String} label - used to define the text to display next to the icon (optional)
 * @prop {Boolean} disabled - used to disable the iconbutton (no pointer events)
 *
 */
let SDBContentSpeedDialButton = class SDBContentSpeedDialButton extends LitElement {
    constructor() {
        super(...arguments);
        this.icon = '';
        this.label = '';
        this.size = 20;
        this.disabled = false;
    }
    render() {
        // rendering <a href=""> results in navigation on click.
        // use a simple span when there's no link property
        return html `
            ${this.label
            ? html `
                      <span class="label">${this.label}</span>
                      <div class="iconWrapper">
                          <sdb-content-icon
                              .size=${this.size}
                              .icon=${this.icon}
                          ></sdb-content-icon>
                      </div>
                  `
            : html `
                      <div class="iconWrapper">
                          <sdb-content-icon
                              .size=${this.size}
                              .icon=${this.icon}
                          ></sdb-content-icon>
                      </div>
                  `}
        `;
    }
};
SDBContentSpeedDialButton.styles = [
    elements,
    css `


  :host{
    width:fit-content;
    display:grid;
    grid-template-columns:1fr 50px;
    place-self:flex-end;
    align-items:center;
    gap:15px;
    margin:10px 0;
    cursor:pointer;
  }

  :host .label{
    background:white;
    color:var(--text-default);
    padding:5px 10px;
    border-radius:5px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: box-shadow: .3s ease;
  }

  :host .iconWrapper{
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:50%;
    background:var(--btn-primary);
    color:var(--text-light);
    width:50px;
    height:50px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: scale .2s ease;
    transition: box-shadow .2s ease;
    -webkit-transform: rotateZ(360deg);
  }

  :host([disabled]){
    pointer-events:none;
}

  :host([disabled]) .label, :host([disabled]) .iconWrapper{
    background:var(--element-lightgrey);
    color:#999;
  }

  :host(:hover) .iconWrapper{
    transform: var(--sdb-button-scale-factor, scale(1.05));
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  }

  :host(:hover) .label{
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  }

  `,
];
__decorate([
    property({ type: String })
], SDBContentSpeedDialButton.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], SDBContentSpeedDialButton.prototype, "label", void 0);
__decorate([
    property({ type: Number })
], SDBContentSpeedDialButton.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentSpeedDialButton.prototype, "disabled", void 0);
SDBContentSpeedDialButton = __decorate([
    customElement('sdb-content-speeddialbutton')
], SDBContentSpeedDialButton);
export { SDBContentSpeedDialButton };
//# sourceMappingURL=sdb-content-speeddialbutton.js.map